import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { quotes } from '../mock';

const QuoteCarousel = () => {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % quotes.length), 6000);
    return () => clearInterval(t);
  }, []);

  const prev = () => setIdx((i) => (i - 1 + quotes.length) % quotes.length);
  const next = () => setIdx((i) => (i + 1) % quotes.length);

  return (
    <section className="relative py-24 md:py-28 overflow-hidden bg-cream">
      {/* Decorative florals */}
      <div className="pointer-events-none absolute -left-24 top-1/3 w-80 h-80 opacity-30">
        <FloralSVG />
      </div>
      <div className="pointer-events-none absolute -right-24 bottom-0 w-96 h-96 opacity-25">
        <FloralSVG />
      </div>

      <div className="relative max-w-4xl mx-auto px-6 text-center">
        {/* Center icon */}
        <div className="mx-auto mb-8 w-24 h-24 dashed-circle flex items-center justify-center">
          <div className="w-16 h-16 rounded-full flex items-center justify-center" style={{ background: 'radial-gradient(circle,#F7D5DA,#EEB1BA)' }}>
            <svg viewBox="0 0 24 24" className="w-9 h-9 text-mahogany" fill="currentColor">
              <path d="M12 2c-1 3-3 4-3 7 0 1.5 1 3 3 3s3-1.5 3-3c0-3-2-4-3-7z" />
              <rect x="11" y="14" width="2" height="6" />
              <path d="M8 20h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </div>
        </div>

        <div className="eyebrow mb-8">— Welcome to Osho Universal —</div>

        <div className="relative min-h-[140px] flex items-center justify-center">
          <button onClick={prev} aria-label="Previous quote" className="absolute left-0 md:-left-8 w-11 h-11 rounded-full bg-rose-soft flex items-center justify-center hover:bg-rose-deep transition-colors">
            <ChevronLeft className="w-5 h-5 text-mahogany" />
          </button>

          <p key={idx} className="font-serif-display text-burgundy text-2xl md:text-[28px] leading-snug px-14 md:px-24 fade-up">
            &ldquo;{quotes[idx]}&rdquo;
            <span className="block mt-3 text-mahogany/70 text-sm not-italic font-sans">— Osho</span>
          </p>

          <button onClick={next} aria-label="Next quote" className="absolute right-0 md:-right-8 w-11 h-11 rounded-full bg-rose-soft flex items-center justify-center hover:bg-rose-deep transition-colors">
            <ChevronRight className="w-5 h-5 text-mahogany" />
          </button>
        </div>

        <div className="mt-8 flex items-center justify-center gap-2">
          {quotes.map((_, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              className={`h-1.5 rounded-full transition-all ${i === idx ? 'w-8 bg-mahogany' : 'w-2 bg-rose-deep/60'}`}
              aria-label={`Quote ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

const FloralSVG = () => (
  <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" fill="#F5C7CD">
    {Array.from({ length: 8 }).map((_, i) => (
      <ellipse
        key={i}
        cx="100"
        cy="55"
        rx="20"
        ry="38"
        transform={`rotate(${i * 45} 100 100)`}
      />
    ))}
    <circle cx="100" cy="100" r="14" fill="#EEB1BA" />
  </svg>
);

export default QuoteCarousel;
